module.exports = __webpack_public_path__ + "img/01.35469458.png";